export function getGradeNameById({grades, id, fallback = '-'}) {
  if (grades && grades.length > 0) {
    return grades.find((item) => item.id === id)?.type || fallback;
  }
  return fallback;
}
